var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TikTok"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5057 6.60628C16.5353 5.97385 15.8353 4.96245 15.6181 3.7845C15.5698 3.52863 15.5457 3.26794 15.5457 3H12.4511L12.4463 15.4023C12.3932 16.7903 11.2514 17.9055 9.84901 17.9055C9.41451 17.9055 9.00416 17.7968 8.64209 17.6061C7.81414 17.1692 7.24689 16.3027 7.24689 15.3033C7.24689 13.8695 8.41277 12.7012 9.84901 12.7012C10.1169 12.7012 10.3728 12.7447 10.6166 12.8219V10.396V9.6622C10.3656 9.6284 10.1097 9.60668 9.84901 9.60668C6.7086 9.60668 4.15234 12.1629 4.15234 15.3033C4.15234 17.2296 5.11547 18.9362 6.58308 19.9669C7.50758 20.6162 8.63485 21 9.8466 21C12.987 21 15.5433 18.4437 15.5433 15.3033V9.01528C16.7574 9.88668 18.2443 10.4008 19.8495 10.4008V7.99664V7.30629C18.9878 7.30387 18.1816 7.04559 17.5057 6.60628Z",
    fill: "#F7FCFD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/TikTok.80bf48318452683eaffb32df81a34eee.svg";
export { ForwardRef as ReactComponent };